import { Popper, styled } from '@mui/material';

export const StyledPopper = styled(Popper)(({ theme: { spacing } }) => ({
  '.MuiMenuItem-root': {
    borderLeft: 'none',
    minWidth: 0,
    padding: spacing(1),
  },
}));
